import { LiksButton } from '../../../components/liks/LiksButton/LiksButton';

type ChatbotSettingsCardFooterProps = {
  isDirty: boolean;
  isSaving: boolean;
  isSaveDisabled: boolean;
  discardLabel: string;
  saveLabel: string;
  onDiscard: () => void;
  onSave: () => void;
};

export function ChatbotSettingsCardFooter({
  isDirty,
  isSaving,
  isSaveDisabled,
  discardLabel,
  saveLabel,
  onDiscard,
  onSave,
}: ChatbotSettingsCardFooterProps) {
  return (
    <div className="chatbot-settings__actions">
      {isDirty ? (
        <LiksButton
          type="button"
          variant="secondary"
          disabled={isSaving}
          onClick={onDiscard}
        >
          {discardLabel}
        </LiksButton>
      ) : null}
      <LiksButton type="button" onClick={onSave} disabled={isSaveDisabled}>
        {saveLabel}
      </LiksButton>
    </div>
  );
}
